import type {PropsWithChildren} from 'react';
import React from 'react';
import type {Resource} from '@igp/shared/access-control';
import {combineResources} from '@igp/shared/access-control';
import type {MenuTreeItemProps} from '@igp/shared/components/menu';
import {MenuTreeItem} from '@igp/shared/components/menu';

import {useBoAgentAccessCheck} from './hooks';

type ProtectedMenuTreeItemProps<TItem extends string = string> = MenuTreeItemProps<TItem> & {resources: Resource[]};

export function ProtectedMenuTreeItem<TItem extends string = string>({
    resources,
    ...props
}: PropsWithChildren<ProtectedMenuTreeItemProps<TItem>>) {
    const resource = combineResources(resources, 'or');
    const hasAccess = useBoAgentAccessCheck(resource);
    return hasAccess ? <MenuTreeItem<TItem> {...props} /> : null;
}
